import React from "react";


export const Header = () => {
  return (
    <header id="header" className="position-relative">
       <section className="landing-intro mt-3">
  <img src="../Images/landing.png" alt="Landing Banner" className="landing-image"/>
</section>
    </header>
  );
};
